import { styled } from '@shared/theme';

// this component might be used outside the ThemeProvider, so theme can't be relied on
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
const ExternalPageCard = styled('div')(({ borderRadius, palette, spacing }) => ({
  backgroundColor: palette?.background.paper ?? '#fff',
  borderRadius: borderRadius?.('l') ?? 10,
  padding: spacing?.(4) ?? 16,
  margin: spacing?.(6) ?? 24,
  display: 'grid',
  gap: spacing?.(2) ?? 8,
  justifyItems: 'center',
  marginBottom: 'auto',
}));

export default ExternalPageCard;
